export default __webpack_public_path__ + "static/media/AssetTypeIcon.c90ce726.svg";